import { VARIANT_ACCENT_HEX, type VariantType } from "@upsquad/shared";
import { useTranslation } from "react-i18next";

interface ThemeSelectorProps {
	value: VariantType;
	onChange: (variant: VariantType) => void;
}

const THEME_OPTIONS: { key: VariantType; labelKey: string }[] = [
	{ key: "default", labelKey: "theme_blue" },
	{ key: "green", labelKey: "theme_green" },
	{ key: "coral", labelKey: "theme_coral" },
	{ key: "sky", labelKey: "theme_sky" },
];

export function ThemeSelector({ value, onChange }: ThemeSelectorProps) {
	const { t } = useTranslation("onboarding");

	return (
		<div>
			<p className="text-sm font-medium mb-3">{t("theme_label")}</p>
			<div className="flex flex-wrap gap-2">
				{THEME_OPTIONS.map(({ key, labelKey }) => {
					const isSelected = value === key;
					const color = VARIANT_ACCENT_HEX[key].light;

					return (
						<button
							key={key}
							type="button"
							onClick={() => onChange(key)}
							className={`flex items-center gap-2 px-4 py-2 rounded-full border text-sm font-medium transition-colors ${
								isSelected ? "border-foreground bg-foreground text-background" : "border-default-300 hover:border-default-400"
							}`}
						>
							<span className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: color }} />
							{t(labelKey as "theme_blue")}
						</button>
					);
				})}
			</div>
		</div>
	);
}
